module.exports = __webpack_public_path__ + "static/media/Homebanner1.26833a51.png";